
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { TrendingUp } from 'lucide-react';
import { fadeInVariants } from '@/lib/animations';

const WorkPerformanceRecommendations = () => {
  return (
    <motion.div 
      className="mt-8 p-6 bg-brand-blue/5 rounded-xl border border-brand-blue/20"
      variants={fadeInVariants}
      initial="initial"
      animate="animate"
      transition={{ delay: 0.4 }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="bg-brand-blue/10 p-3 rounded-full">
            <TrendingUp className="text-brand-blue w-6 h-6" />
          </div>
          <div>
            <h3 className="font-medium text-lg">Recomendações de Performance</h3>
            <p className="text-sm text-gray-600">Baseado nos seus padrões recentes de trabalho</p>
          </div>
        </div>
        <Button variant="outline" className="border-brand-blue text-brand-blue hover:bg-brand-blue/10">
          Ver Recomendações
        </Button>
      </div>
    </motion.div>
  );
};

export default WorkPerformanceRecommendations;
